// src/config.js
const API_BASE_URL = "http://114.29.239.77:7266/";

export default API_BASE_URL;
 
 
